import React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { UserX, Home, Clock } from "lucide-react";

interface KickedFromBoothModalProps {
  isOpen: boolean;
  boothName: string;
  reason?: string;
  banDurationMinutes?: number;
  onClose: () => void;
  onGoHome: () => void;
}

const KickedFromBoothModal: React.FC<KickedFromBoothModalProps> = ({
  isOpen,
  boothName,
  reason,
  banDurationMinutes = 60,
  onClose,
  onGoHome,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-sm text-center rounded-3xl">
        <div className="py-6">
          {/* Icon */}
          <div className="mx-auto w-20 h-20 rounded-full bg-red-500/10 flex items-center justify-center mb-6">
            <UserX className="w-10 h-10 text-red-500" />
          </div>

          {/* Title */}
          <h2 className="text-xl font-bold text-foreground mb-2">
            Removed from Stage
          </h2>

          {/* Message */}
          <p className="text-muted-foreground mb-4">
            You've been removed from <span className="font-semibold">"{boothName}"</span>
          </p>

          {/* Reason (if provided) */}
          {reason && (
            <div className="mx-4 p-3 rounded-xl bg-muted/50 text-sm text-muted-foreground mb-4">
              <p className="font-medium text-foreground mb-1">Reason:</p>
              <p>{reason}</p>
            </div>
          )}

          {/* Ban duration */}
          <div className="flex items-center justify-center gap-2 text-sm text-amber-600 mb-6">
            <Clock className="w-4 h-4" />
            <span>You can rejoin after {banDurationMinutes} minutes</span>
          </div>

          {/* Actions */}
          <div className="flex flex-col gap-2">
            <Button
              onClick={onGoHome}
              className="w-full gap-2 rounded-full"
            >
              <Home className="w-4 h-4" />
              Return to Exhibition
            </Button>
            <Button
              variant="ghost"
              onClick={onClose}
              className="w-full rounded-full"
            >
              Dismiss
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default KickedFromBoothModal;
